<template>
  <app-layout>
    <template v-slot:header>
      <AppHead title="Manage Images" />
      <h2>Images for Product {{ form.name }}</h2>
      <flash-messages />
    </template>
        
    <template v-slot:default>
      <div id="manageImages" class="mt-4">
        <ReorderImages :images="images" :product="product" />

        <form @submit.prevent="update" class="col-12 mt-4">
          <div class="row">
            <div class="form-group col-12 col-lg-6 px-0">
              <jet-label for="photo" value="Add Images" />
              <div v-bind="getRootProps()" id="file_select">
                <input v-bind="getInputProps()" >
                <p v-if="isDragActive">Drop the files here ...</p>
                <p v-else>Drag files here, or click Select Files</p>
                <div v-if="isFocused" id="focus">focused</div>
                <div v-if="isDragReject" id="isDragReject">
                  isDragReject: {{ isDragReject }}
                </div>
              </div> 
                  
              <jet-button @click="openClick" icon="fas fa-images" class="mt-2">
              Select Files
              </jet-button>
              <jet-input-error :message="form.errors.photo" class="mt-2" />
            </div>
          </div>         
        </form>
      </div>
    </template>
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import FlashMessages from '@/Shared/FlashMessages'

  import JetButton from '@/Jetstream/Button'
  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import { useDropzone } from "vue3-dropzone"

  import ReorderImages from '@/Components/Products/ReorderImages'

  export default {
    metaInfo() {
      return {
        title: `Edit Product: ${this.form.name}`,
      }
    },
    components: {
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      AppLayout,
      FlashMessages,
      ReorderImages
    },
    props: {
      product: Object,
      images: Object
    },
    remember: 'form',
    data() {
      return {
        form: this.$inertia.form({
          _method: 'put',
          name: this.product.name,
          sku: this.product.sku,
          photo: null,
        })
      }
    },
    methods: {
      openClick() {
        if (this.open) this.open()
      },
      uploadImage() {
        this.form.post(this.route('mtd.products.addImage', this.product.id), {
          onSuccess: () => this.form.reset('photo'),
        })
      },
      update() {
        this.form.post(this.route('mtd.products.addImage', this.product.id), {
          onSuccess: () => this.form.reset('photo'),
        })
      },
    },
    setup(props, context) {
      // no route helper method available here
      const url = '/mtd/products/' + props.product.id + '/addImages'; 
      const saveFiles = (files) => {
        const formData = new FormData(); // pass data as a form
        for (var x = 0; x < files.length; x++) {
          // append files as array to the form, feel free to change the array name
          formData.append("images[]", files[x]);
        }

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            window.location.reload();
          })
          .catch((err) => {
            console.error(err);
          });
      };

      function onDrop(acceptFiles, rejectReasons) {
        saveFiles(acceptFiles); // saveFiles as callback
      }

      const { getRootProps, getInputProps, ...rest } = useDropzone({ onDrop });

      return {
        getRootProps,
        getInputProps,
        ...rest,
      };
    },
  }
</script>

<style>
  #file_select {
    border: 2px dashed #0087F7;
    border-radius: 5px;
    background: white;
    min-height: 150px;
    padding: 50px;
  }
</style>